import { Disc3, Mic2, Music2 } from 'lucide-react'

import { CategoryTabs } from '@/components/ui'

export const SEARCH_MODES = ['songs', 'albums', 'artists'] as const
export type SearchMode = (typeof SEARCH_MODES)[number]
export const SEARCH_PANEL_ID = 'search-results-panel'
export const searchTabId = (mode: SearchMode) => `search-tab-${mode}`

export interface SearchModeToggleProps {
  value: SearchMode
  onChange: (mode: SearchMode) => void
  albumsDisabled?: boolean
  albumsReason?: string
  artistsDisabled?: boolean
  artistsReason?: string
  className?: string
}

export function SearchModeToggle({
  value, onChange, albumsDisabled, albumsReason, artistsDisabled, artistsReason, className,
}: SearchModeToggleProps) {
  return (
    <CategoryTabs
      value={value}
      onChange={onChange}
      label="What to search for"
      tabId={searchTabId}
      panelId={SEARCH_PANEL_ID}
      className={className}
      options={[
        { value: 'songs', label: 'Songs', icon: Music2 },
        { value: 'artists', label: 'Artists', icon: Mic2, disabled: artistsDisabled, reason: artistsReason },
        { value: 'albums', label: 'Albums', icon: Disc3, disabled: albumsDisabled, reason: albumsReason },
      ]}
    />
  )
}
